import { render, staticRenderFns } from "./specialCharPicker.vue?vue&type=template&id=0f3d96c2&scoped=true&"
import script from "./specialCharPicker.vue?vue&type=script&lang=js&"
export * from "./specialCharPicker.vue?vue&type=script&lang=js&"
import style0 from "./specialCharPicker.vue?vue&type=style&index=0&id=0f3d96c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3d96c2",
  null
  
)

export default component.exports